import React, { useEffect, useState } from 'react';
import NewPreview from '../../Modals/NewPreview';
import imagePlaceholder from 'static/images/placeholder-image.png';
import Loading from 'components/Loading/Loading';

import { Box } from '@chakra-ui/react';

import { useLazyGetTemplateByIdQuery } from 'modules/templates/templatesApi';

const TemplatePreview = ({ templateID, openModal, setPreviewModal }) => {
  const [previewData, setPreviewData] = useState(null);
  const [loading, setLoading] = useState(false);

  const [getTemplateById] = useLazyGetTemplateByIdQuery();

  useEffect(() => {
    if (!templateID) {
      setPreviewData(null);
      return;
    }

    const fetchPreview = async () => {
      setLoading(true);
      try {
        const template = await getTemplateById(templateID).unwrap();
        if (!template || templateID === 0) return;

        if (!template.double_sided) {
          setPreviewData({
            previewSrc: template.bg_img?.original_url || null,
            originalSrc: template.bg_img?.original_url || null,
            doubleSided: false,
          });
        } else {
          const pages = [...template.ad_template_pages].sort(
            (a, b) => a.page_num - b.page_num
          );
          setPreviewData({
            previewSrc: pages[0]?.bg_img?.original_url || null,
            originalSrc: pages[0]?.bg_img?.original_url || null,
            previewSecondSrc: pages[1]?.bg_img?.original_url || null,
            originalSecondSrc: pages[1]?.bg_img?.original_url || null,
            doubleSided: true,
          });
        }
      } catch (err) {
        console.error('Failed to fetch template', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPreview();
  }, [templateID, getTemplateById]);

  if (loading) {
    return (
      <Box className="cmp-details__ad-template-preview">
        <Loading />
      </Box>
    );
  }

  if (!previewData) return null;

  return (
    <Box
      className="cmp-details__ad-template-preview"
      onClick={() =>
        openModal(
          setPreviewModal,
          null,
          'Template Background Preview',
          <NewPreview
            creative={{
              original_url: previewData.originalSrc,
              filename: 'Insert',
              originalSecondSrc: previewData.originalSecondSrc,
            }}
          />
        )
      }
    >
      <img src={previewData.previewSrc || imagePlaceholder} alt="" />
      {previewData.doubleSided && (
        <img
          style={{ marginLeft: '10px' }}
          src={previewData.previewSecondSrc || imagePlaceholder}
          alt=""
        />
      )}
    </Box>
  );
};

export default TemplatePreview;
